import { RouterProvider as AriaRouterProvider } from 'react-aria-components';
import { Outlet, ScrollRestoration, useHref, useMatches, useNavigate } from 'react-router';

// react-router's useHref turns every href into an app route ('mailto:x' → '/current/mailto:x'), so links with a
// scheme (mailto:, https:, blob:) are passed through untouched. useHref is still called to keep the hook order stable.
const useAppHref = (href: string) => {
    const routerHref = useHref(href);
    return /^[a-z][a-z\d+.-]*:/i.test(href) ? href : routerHref;
};

const RootLayout = () => {
    const navigate = useNavigate();
    const isInAppFrame = useMatches().some((match) => match.id === 'app');

    return (
        <AriaRouterProvider navigate={navigate} useHref={useAppHref}>
            <Outlet />
            {/* Pages outside the app's frame (the start page, the legal pages, signing in, public links) scroll the
                window: a link opens them at the top, going back where they were. AppLayout does the same for its
                <main>, which this doesn't reach. Left out in the frame, since it would jump to a linked section
                (`#todos`) at once, before the page can scroll to it smoothly (useScrollToSection). */}
            {!isInAppFrame && <ScrollRestoration />}
        </AriaRouterProvider>
    );
};

export default RootLayout;
